// src/lib/rbac/scopes.ts

/**
 * Scope suffixes applied to permissions like `client:read_own`.
 * Service layer (backend) enforces the actual scope; frontend uses these
 * to resolve whether a role has ANY variant of an action.
 *
 * Mirrors elixaa-api/src/configs/permissionsConfig.ts SCOPE_SUFFIXES.
 */
export const SCOPE_SUFFIXES = ['_own', '_assigned', '_basic', '_profile'] as const;

export type ScopeSuffix = (typeof SCOPE_SUFFIXES)[number];

/**
 * Action qualifiers — underscored segments that are part of the action name,
 * NOT scopes. `client:read_phi` is a distinct action from `client:read`.
 *
 * Mirrors elixaa-api/src/configs/permissionsConfig.ts ACTION_QUALIFIERS.
 */
export const ACTION_QUALIFIERS = ['_phi'] as const;

export type ActionQualifier = (typeof ACTION_QUALIFIERS)[number];
